import NTNavbar from "@/components/feature/NTNavbar";
import NTFooter from "@/components/feature/NTFooter";
import { Link } from "react-router-dom";

const allServices = [
  {
    id: 2,
    icon: "ri-tools-line",
    title: "Fabricação de Máquinas Especiais",
    desc: "Desenvolvimento e fabricação de máquinas e equipamentos especiais totalmente personalizados. Do projeto à entrega, nossa equipe de engenharia cria soluções únicas para cada desafio.",
    features: ["Projeto mecânico e estrutural", "Usinagem de precisão", "Montagem e testes", "Documentação técnica completa", "Capacitação operacional"],
    image: "https://readdy.ai/api/search-image?query=custom%20special%20machine%20fabrication%20industrial%20workshop%20metal%20machining%20precision%20engineering%20manufacturing%20bright%20clean%20professional&width=700&height=480&seq=ntsvc_full2&orientation=landscape",
  },
  {
    id: 3,
    icon: "ri-settings-line",
    title: "Acessórios para Equipamentos",
    desc: "Linha completa de acessórios e componentes industriais de alta performance para manutenção, upgrade e otimização de equipamentos existentes em sua linha de produção.",
    features: ["Componentes mecânicos sob medida", "Upgrade de sistemas elétricos", "Peças de reposição", "Consultoria técnica"],
    image: "https://readdy.ai/api/search-image?query=industrial%20equipment%20accessories%20components%20parts%20mechanical%20engineering%20precision%20tools%20bright%20clean%20background%20professional&width=700&height=480&seq=ntsvc_full3&orientation=landscape",
  },
  {
    id: 4,
    icon: "ri-refresh-line",
    title: "Retrofit e Modernização",
    desc: "Atualização tecnológica de equipamentos existentes, prolongando a vida útil e aumentando significativamente a eficiência operacional sem necessidade de substituição completa.",
    features: ["Diagnóstico técnico completo", "Substituição de componentes obsoletos", "Atualização de sistemas de controle", "Melhoria de segurança", "Aumento de produtividade"],
    image: "https://readdy.ai/api/search-image?query=industrial%20machine%20retrofit%20modernization%20upgrade%20electrical%20panel%20control%20system%20engineering%20bright%20workshop%20professional&width=700&height=480&seq=ntsvc_full4&orientation=landscape",
  },
  {
    id: 5,
    icon: "ri-draft-line",
    title: "Engenharia de Projetos",
    desc: "Consultoria e desenvolvimento de projetos industriais completos, do conceito à implementação. Nossa equipe de engenheiros oferece suporte técnico especializado em todas as etapas.",
    features: ["Análise de viabilidade técnica", "Projeto conceitual e detalhado", "Simulações e protótipos", "Gestão de projetos", "Suporte pós-implementação"],
    image: "https://readdy.ai/api/search-image?query=industrial%20engineering%20project%20design%20CAD%20blueprint%20technical%20drawing%20professional%20engineer%20bright%20office%20modern&width=700&height=480&seq=ntsvc_full5&orientation=landscape",
  },
  {
    id: 6,
    icon: "ri-customer-service-2-line",
    title: "Assistência Técnica",
    desc: "Nossa equipe de engenharia especializada oferece manutenção preventiva e corretiva.",
    features: ["Manutenção preventiva programada", "Diagnóstico remoto", "Relatórios técnicos detalhados"],
    image: "https://readdy.ai/api/search-image?query=industrial%20technical%20assistance%20maintenance%20engineer%20working%20machinery%20repair%20professional%20bright%20factory%20clean&width=700&height=480&seq=ntsvc_full6&orientation=landscape",
  },
];

const segments = [
  { icon: "ri-restaurant-line", label: "Alimentício" },
  { icon: "ri-hammer-line", label: "Metalúrgico" },
  { icon: "ri-scissors-line", label: "Têxtil" },
  { icon: "ri-car-line", label: "Automobilístico" },
  { icon: "ri-drop-line", label: "Higiene Pessoal" },
];

export default function ServicosPage() {
  return (
    <div className="min-h-screen bg-white font-inter">
      <NTNavbar />
      <main className="pt-[88px]">

        {/* Hero */}
        <section className="relative h-[340px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=industrial%20services%20engineering%20team%20factory%20floor%20machinery%20professional%20bright%20clean%20modern%20manufacturing%20plant&width=1400&height=400&seq=ntsvchero&orientation=landscape"
            alt="Serviços New Tech Solution"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a]/80 via-[#1a1a1a]/50 to-transparent"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 w-full">
              <div className="flex items-center gap-2 mb-3">
                <Link to="/" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">Home</Link>
                <span className="text-white/40 text-sm">/</span>
                <span className="text-[#3FA7D6] text-sm font-semibold">Serviços</span>
              </div>
              <h1 className="font-rajdhani font-bold text-white text-4xl md:text-5xl">Nossas Soluções Industriais</h1>
              <p className="text-white/70 text-base mt-2">Soluções completas para cada desafio da sua indústria.</p>
            </div>
          </div>
        </section>

        {/* Segments */}
        <section className="bg-[#1B1F5E] py-5">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
              {segments.map((s) => (
                <div key={s.label} className="flex items-center gap-2 text-white cursor-pointer hover:opacity-80 transition-opacity">
                  <div className="w-5 h-5 flex items-center justify-center"><i className={`${s.icon} text-base`}></i></div>
                  <span className="font-rajdhani font-bold text-sm uppercase tracking-wider whitespace-nowrap">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services list */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-col gap-20">
              {allServices.map((svc, idx) => (
                <div key={svc.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${idx % 2 !== 0 ? "lg:flex-row-reverse" : ""}`}>
                  {/* Image */}
                  <div className={`w-full h-[360px] rounded-lg overflow-hidden ${idx % 2 !== 0 ? "lg:order-2" : ""}`}>
                    <img src={svc.image} alt={svc.title} className="w-full h-full object-cover object-top" />
                  </div>
                  {/* Content */}
                  <div className={idx % 2 !== 0 ? "lg:order-1" : ""}>
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1B1F5E]/10 text-[#1B1F5E] mb-5">
                      <i className={`${svc.icon} text-2xl`}></i>
                    </div>
                    <h2 className="font-rajdhani font-bold text-[#1a1a1a] text-3xl mb-3">{svc.title}</h2>
                    <p className="text-[#555] text-sm leading-relaxed mb-6">{svc.desc}</p>
                    <ul className="flex flex-col gap-2 mb-7">
                      {svc.features.map((f) => (
                        <li key={f} className="flex items-center gap-2 text-sm text-[#333]">
                          <div className="w-4 h-4 flex items-center justify-center text-[#1B1F5E] shrink-0"><i className="ri-checkbox-circle-fill text-sm"></i></div>
                          {f}
                        </li>
                      ))}
                    </ul>
                    <Link to="/contato" className="inline-flex items-center gap-2 bg-[#1B1F5E] hover:bg-[#2F4F8F] text-white font-bold px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm">
                      Solicitar Orçamento
                      <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-[#f5c518] py-5">
          <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-rajdhani font-black text-[#1a1a1a] text-xl md:text-2xl uppercase">PRECISA DE UMA SOLUÇÃO PERSONALIZADA?</p>
              <p className="text-[#1a1a1a]/70 text-sm mt-0.5">Nossa equipe está pronta para desenvolver o projeto ideal para você.</p>
            </div>
            <Link to="/contato" className="whitespace-nowrap bg-[#1a1a1a] hover:bg-[#333] text-white font-bold px-8 py-3 rounded-md transition-colors cursor-pointer text-sm">
              Fale com um Especialista
            </Link>
          </div>
        </section>

      </main>
      <NTFooter />
    </div>
  );
}
